module.exports = __webpack_public_path__ + "static/img/ask2-bg.49e4a78.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4/ask2-bg.png
// module id = eoIa
// module chunks = 0